module.exports = __webpack_public_path__ + "static/media/5.8900df40.png";